import React from "react";
import "./Footer.css"; // Make sure to create and import this CSS file
import facebookIcon from "./assets/facebook.png";
import youtubeIcon from "./assets/youtube.png";
import linkedinIcon from "./assets/linkedin.png";
import { openCookieSettings } from "./components/CookieBanner";

const Footer = () => {
  return (
    <footer className="gofoton-footer">
      <div className="footer-container">
        <div className="footer-column-2">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FGoFoton%20Logo-k%20(R).png?alt=media&token=6fa4c257-8569-4f86-af93-320f2b64a527"
            alt="GoFoton Logo"
            className="footer-logo"
          />
          <p className="footer-description">
            Go!Foton is a global photonics company with a strong presence in the optical communications industry. We
            grow our business by helping our customers create competitive advantages with our innovative solutions.
          </p>
          <div className="footer-socials">
            <a href="https://www.youtube.com/@gofoton4899" target="_blank" rel="noreferrer">
              <img className="icon-white" src={youtubeIcon} alt="YouTube" style={{ height: 24, marginRight: 10 }} />
            </a>
            <a href="https://www.linkedin.com/company/gofoton/" target="_blank" rel="noreferrer">
              <img className="icon-white" src={linkedinIcon} alt="LinkedIn" style={{ height: 24 }} />
            </a>
          </div>
        </div>

        <div className="footer-column" style={{ marginLeft: 50 }}>
          <h3>Offices</h3>

          <p>
            <a href="tel:+17324699650">USA: +1 732 469 9650</a>
          </p>
          <p>
            <a href="tel:+31164620422">Europe: +31 164 62 04 22</a>
          </p>
          <p>
            <a href="tel:+81298478686">Japan: +81 029 847 8686</a>
          </p>
          <p>
            <a href="tel:+862552163442">China: +86 25 5216 3442</a>
          </p>
          <p>
            <a href="tel:+63495086089">Philippines: +63 49 508 6089</a>
          </p>
        </div>

        <div className="footer-column">
          <h3>Quick Links</h3>
          <p>
            <a href="/products">Products</a>
          </p>
          <p>
            <a href="/services">Services</a>
          </p>
          <p>
            <a href="/solutions">Solutions</a>
          </p>
          <p>
            <a href="/part-lookup">Part Number Lookup</a>
          </p>
          <p>
            <a href="/about">About</a>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <div className="footer-copyright">© {new Date().getFullYear()} Go!Foton</div>
          <div className="footer-legal-links">
            <a href="/privacy-policy">Privacy Policy</a>

            <button type="button" className="footer-cookie-settings" onClick={openCookieSettings}>
              Cookie Preferences
            </button>

            <a href="/site-map">Site Map</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
